interface ClockIconProps {
  className?: string;
}

export function ClockIcon({ className }: ClockIconProps) {
  return (
    <svg
      width="19.95"
      height="19.95"
      viewBox="0 0 19.95 19.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_clock)">
        <path
          d="M0.998047 9.97457C0.998047 12.3556 1.94389 14.639 3.6275 16.3226C5.3111 18.0062 7.59457 18.9521 9.97555 18.9521C12.3565 18.9521 14.64 18.0062 16.3236 16.3226C18.0072 14.639 18.953 12.3556 18.953 9.97457C18.953 7.59359 18.0072 5.31013 16.3236 3.62652C14.64 1.94291 12.3565 0.99707 9.97555 0.99707C7.59457 0.99707 5.3111 1.94291 3.6275 3.62652C1.94389 5.31013 0.998047 7.59359 0.998047 9.97457Z"
          stroke="#A8B4BD"
          strokeWidth="1.995"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.9754 6.52148V9.97483L13.4846 14.0686"
          stroke="#A8B4BD"
          strokeWidth="1.995"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_clock">
          <rect width="19.95" height="19.95" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
